import React, { useState, useCallback, useEffect } from "react";
import { BiCalendarAlt, BiMap, BiSolidCircle } from "react-icons/bi";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import { Helmet } from "react-helmet-async";
import Header from "../Header";
import Footer from "../Footer";
import TruncatedView from "../TruncatedView";
import Loading from "../Loading";
import { useNavigate } from "react-router-dom";

const BookingList = () => {
  const navigate = useNavigate();
  const customertoken = localStorage.getItem("customertoken");
  // console.log(customertoken)
  const [bookingDetails, setBookingDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getFullDetails = useCallback(() => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);
    // const formdata = new FormData();
    // formdata.append("id", bookingid);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      // body: formdata,
      redirect: "follow",
    };

    fetch(HTTP_BASE_URL + "getCustomerEnquiry", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.code === 0) {
          setBookingDetails(result.data); // Store the data in state
          //  console.log('locations', result);
        } else if (result?.code === 1) {
          navigate("/");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [customertoken, navigate]);

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    setIsLoading(true);
    getFullDetails();
    tokenExpiry();
    // const timer = setTimeout(() => {
    //   setIsLoading(false);
    // }, 1200);
    // return () => clearTimeout(timer);
  }, [getFullDetails, tokenExpiry]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>All Booking</title>
      </Helmet>
      <Header />
      <div className="container-fluid booking-list-banner booking-section">
        <div className="container">
          <div className="booking-list pt-lg-4 pb-lg-5">
            {bookingDetails &&
              bookingDetails.map((booking, index) => (
                <div className="bookingDetails" key={booking.id}>
                  <div className="pb-1 border-bottom">
                    <div className="flex">
                      <p className="sub-heading">
                        #{booking && booking?.enqno ? booking?.enqno : ""}
                        {/* <span className="text-para black">
                          #{booking && booking?.enqno ? booking?.enqno : ""}
                        </span> */}
                      </p>
                      <div className="circle">
                        {booking?.booking_status === "" ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#D7000C" }}
                          >
                            <BiSolidCircle /> {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 0 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#000" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 1 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#000" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 2 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "orange" }}
                          >
                            <BiSolidCircle />
                            {/* {booking?.booking_status_name} */}
                            Awaiting Quote
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 3 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "orange" }}
                          >
                            <BiSolidCircle />
                            {/* {booking?.booking_status_name} */}
                            Quotation Received
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 4 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "orange" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 5 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#1677a3" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 6 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#01c3c6" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 7 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#01c3c6" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 8 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#8A2BE2" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 9 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#8A2BE2" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 10 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#FF15BD" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 11 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#D1C31C" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 12 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#3D29AF" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 13 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#AF388E" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 14 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#717D9C" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 15 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#2FCC30" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 16 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#ff6347" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 17 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#16825a" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                        {booking?.booking_status === 18 ? (
                          <span
                            className="sub-heading"
                            style={{ color: "#ff6347" }}
                          >
                            <BiSolidCircle />
                            {booking?.booking_status_name}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <p className="text-para f-12">
                      {booking?.created_at || "Null"}
                    </p>
                  </div>
                  <div className="pt-4 pb-2 border-bottom">
                    {booking ? (
                      booking?.carno === "null" || !booking?.carno ? (
                        <>
                          <p className="sub-heading f-15 text-center d-inline-block ">
                            <span className="text-span black Moulpali">
                              <span className="carno-firstline">**</span>
                              <br />
                              ****
                            </span>
                          </p>
                        </>
                      ) : (
                        <>
                          <p className="sub-heading f-15 text-center d-inline-block ">
                            <span className="text-span black Moulpali">
                              <span className="carno-firstline">
                                {booking.carno.replace(/\s/g, "").slice(0, 4)}
                              </span>
                              <br />
                              {booking.carno.replace(/\s/g, "").slice(4)}
                            </span>
                          </p>
                        </>
                      )
                    ) : (
                      ""
                    )}

                    <div className="location-flex pt-3 dots">
                      <BiMap className="red" style={{ flexShrink: "0" }} />
                      <span className="text-para black">
                        <TruncatedView
                          text={booking?.pickuplocation}
                          maxLength={20}
                          // placeholder="NA"
                        />
                      </span>
                    </div>
                    <div className="location-flex pt-1">
                      <BiMap style={{ flexShrink: "0" }} />
                      <span className="text-para black ">
                        <TruncatedView
                          text={booking?.deliverylocation}
                          maxLength={20}
                          // placeholder="NA"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="flex pt-4">
                    <span className="sub-heading">
                      <p className="text-para">Pickup Date & Time</p>
                      <BiCalendarAlt className="red" />
                      {booking
                        ? booking?.pickuptime === "null" || !booking?.pickuptime
                          ? "NA"
                          : booking?.pickuptime
                        : ""}
                    </span>
                    <button
                      className="reschedule-btn red"
                      onClick={() => {
                        navigate(`/booking/${booking.enqno}`);
                      }}
                    >
                      View Booking
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookingList;
